export var Projects;
(function (Projects) {
    Projects["zenitbet"] = "zenitbet";
    Projects["mobile_com"] = "mobile_com";
    Projects["desktop"] = "desktop";
    Projects["mobile_new"] = "mobile_new";
    Projects["zenitbet_classic"] = "zenitbet_classic";
    Projects["cupis"] = "cupis";
    Projects["mobile"] = "mobile";
})(Projects || (Projects = {}));



// WEBPACK FOOTER //
// ./src/web-frontend-core/utils/enums/projects.js